import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Ornament } from "../components/Ornament";

/**
 * PROMPT 4 PART 1 — first onboarding screen.
 * Two large cards: "Someone I love" (default, comes first) and "Myself".
 * The choice sets the flow that OnboardingStorytellerDetails renders.
 */
export default function OnboardingWho() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/story-week/intro";
  const go = (mode) => navigate(`/onboarding/storyteller/details?mode=${mode}&next=${encodeURIComponent(next)}`);

  return (
    <div className="min-h-screen" style={{ background: "#FAF7F2" }} data-testid="onboarding-who-page">
      <main className="max-w-2xl mx-auto px-6 py-16 sm:py-20">
        <p className="label-ui text-[11px] text-[#B8973A] tracking-[0.35em] text-center">✦ THE LIVING BOOK ✦</p>
        <Ornament className="my-6" />
        <h1 className="text-center text-[#111D33]"
            style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontWeight: 300,
                     fontSize: "clamp(2rem, 5.5vw, 2.75rem)", lineHeight: 1.15 }}
            data-testid="onboarding-who-heading">
          Whose stories are we keeping?
        </h1>
        <p className="text-center mt-4 text-[#5C5548] italic"
           style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "1.2rem", lineHeight: 1.6 }}>
          The Living Book works best when it's a conversation. Choose the way that fits you.
        </p>

        <div className="mt-12 space-y-5">
          {/* Someone I love — default, first */}
          <button type="button" onClick={() => go("someone")}
                  className="w-full text-left bg-white hairline-cream p-6 sm:p-8 hover:bg-[#F7F1E5] transition"
                  style={{ borderRadius: 4, minHeight: 140 }}
                  data-testid="onboarding-who-someone-btn">
            <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.3em]">CHOICE ONE</p>
            <h2 className="mt-2 text-[#111D33]"
                style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 400,
                         fontSize: "clamp(1.6rem, 4.5vw, 2rem)", lineHeight: 1.2 }}>
              Someone I love
            </h2>
            <p className="mt-2 text-[#1B2A4A]" style={{ fontFamily: "Georgia, serif", fontSize: "16px", lineHeight: 1.6 }}>
              I'll sit down with them and ask the questions. We'll turn our conversations into their book.
            </p>
          </button>

          {/* Myself */}
          <button type="button" onClick={() => go("myself")}
                  className="w-full text-left bg-white hairline-cream p-6 sm:p-8 hover:bg-[#F7F1E5] transition"
                  style={{ borderRadius: 4, minHeight: 140 }}
                  data-testid="onboarding-who-myself-btn">
            <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.3em]">CHOICE TWO</p>
            <h2 className="mt-2 text-[#111D33]"
                style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 400,
                         fontSize: "clamp(1.6rem, 4.5vw, 2rem)", lineHeight: 1.2 }}>
              Myself
            </h2>
            <p className="mt-2 text-[#1B2A4A]" style={{ fontFamily: "Georgia, serif", fontSize: "16px", lineHeight: 1.6 }}>
              I'll answer the questions on my own. My Living Book will be my own story.
            </p>
          </button>
        </div>
      </main>
    </div>
  );
}
